<template>
    <div class="page-wework-tabs">
        <v-tabs
            v-model="tabVal"
            @change="onTabChange"
        >
            <v-tab value="account">
                {{ $t('账号配置') }}
            </v-tab>
            <!-- 私有化不展示应用管理页面 -->
            <template v-if="!isPrivate">
                <v-tab value="app">
                    {{ $t('应用管理') }}
                </v-tab>
            </template>
        </v-tabs>
        <router-view v-bind="$attrs" />
    </div>
</template>

<script>
import LampTip from '@/components/lamp-tip';
import { isPrivate } from 'src/config/private';

export default {
    components: {
        LampTip,
    },

    data() {
        return {
            tabVal: 'account',
            routeTabMap: {
                '/mng/weworkAccount/index': 'account',
                '/mng/weworkAccount/index/app': 'app',
                '/mng/weworkAccount/index/': 'account',
            },
            isPrivate,
        };
    },

    watch: {
        $route() {
            this.setTabValByRoute();
        },
    },

    created() {
        this.setTabValByRoute();
    },

    methods: {
        setTabValByRoute() {
            this.tabVal = this.routeTabMap[this.$route.path];
        },

        onTabChange(val) {
            if (val === 'app') {
                this.$router.push('/mng/weworkAccount/index/app');
            } else {
                this.$router.push('/mng/weworkAccount/index');
            }
        },
    },
};
</script>
<style scoped lang="less">
@import './tabs-router.less';
</style>
